import * as XLSX from 'xlsx';
import { buildExportAoa, safeExportFilename } from '../../lib/exportCells.js';
import { downloadBlob, XLSX_MIME } from '../../lib/downloadBlob.js';

/**
 * Sprint 22 — Export Excel WYSIWYG (RG-EXPORT-01/02/03).
 *
 * Export client-side : exporte EXACTEMENT les lignes affichées (les `rows`
 * déjà chargées avec les filtres courants), pas une requête serveur séparée.
 * Les cellules sont neutralisées contre la formula injection (F-S22-01,
 * `sanitizeCell` dans lib/exportCells.js).
 *
 * Téléchargement via `downloadBlob` plutôt que `XLSX.writeFile` : sous Safari,
 * ce dernier produisait `unknown.xlsx` (ticket support #29).
 *
 * @param {Array<Object>} rows    lignes à exporter (objets bruts).
 * @param {Array<{key:string,label:string,format?:(v:any,row:Object)=>any}>} columns
 *        définition des colonnes = en-têtes affichés, dans l'ordre.
 * @param {string} filename  nom de fichier (sans extension).
 */
export function exportRowsToXlsx(rows, columns, filename = 'export') {
  const ws = XLSX.utils.aoa_to_sheet(buildExportAoa(rows, columns));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Time tracking');
  const data = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([data], { type: XLSX_MIME });
  downloadBlob(blob, `${safeExportFilename(filename)}.xlsx`);
}
